<div mat-dialog-title class="dialog-header">
    <div class="header-title">
        <svg-icon class="d-inline-block me-2" src="assets/images/svg/nav-bar/Dashboard Report.svg"
            [svgStyle]="{ 'width.px':20,'height.px': 20,'fill':'#000'}">
        </svg-icon>
        <span class="title-text">Dashboard Report</span>
        <div class="mode-toggle-group">
            <button mat-button [class.active]="dashboardMode === 'my-utilities'" (click)="switchMode('my-utilities')">
                My Utilities
            </button>
            <button mat-button [class.active]="dashboardMode === 'live-data'" (click)="switchMode('live-data')">
                Live Data
            </button>
        </div>
    </div>
    <div class="header-controls">
        <div class="period-selector">
            <button mat-button *ngFor="let button of buttonList"
                [class.active]="selectedPeriod === button.period"
                (click)="onPeriodChange(button.period)">
                {{button.name}}
            </button>
        </div>
        <div class="header-datepicker">
            <mat-form-field appearance="outline" class="compact-datepicker">
                <mat-label>Reference Date</mat-label>
                <input matInput [matDatepicker]="picker" [formControl]="referenceDate" (dateChange)="onDateChange($event)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </div>
    </div>
</div>

<mat-dialog-content class="dialog-content">
    <!-- Live Data View -->
    <div *ngIf="dashboardMode === 'live-data'" class="latest-container">
        <!-- Main Loading -->
        <div *ngIf="latestLoading" class="latest-state-container">
            <mat-spinner [diameter]="45"></mat-spinner>
        </div>

        <!-- Main Error -->
        <div *ngIf="!latestLoading && latestError" class="latest-state-container error-state">
            <p class="error-text">{{latestError}}</p>
            <button mat-raised-button color="warn" (click)="loadLatestReadings()">Retry</button>
        </div>

        <!-- Main Empty -->
        <div *ngIf="!latestLoading && !latestError && latestReadings.length === 0" class="latest-state-container empty-state">
            <p class="empty-text">No configured categories found for this site.</p>
        </div>

        <!-- Full Cards Grid -->
        <div *ngIf="!latestLoading && !latestError && latestReadings.length > 0" class="cards-grid">
            <div *ngFor="let category of latestReadings" class="category-card" [class.stale]="category.selectedReading?.isStale" [class.incomplete]="category.selectedReading?.isIncomplete">
                <div class="card-header">
                    <div class="header-left">
                        <h3>{{cleanTitle(category.categoryName)}}</h3>

                        <!-- Dropdown selector (only if multiple readings exist) -->
                        <div class="selector-wrapper" *ngIf="category.readings && category.readings.length > 1">
                            <select class="reading-select" [value]="category.selectedReading?.logicalGroupId" (change)="onReadingChange(category, $any($event.target).value)">
                                <option *ngFor="let reading of category.readings" [value]="reading.logicalGroupId">
                                    {{reading.name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <button mat-button *ngIf="category.chartData && !category.isLoading"
                            class="export-btn" (click)="exportToCSV(category)">
                        Export CSV
                    </button>
                </div>

                <div class="card-content-area">
                    <!-- Loading Spinner -->
                    <div *ngIf="category.isLoading" class="state-container">
                        <mat-spinner [diameter]="40"></mat-spinner>
                    </div>

                    <!-- Error / Empty State Message -->
                    <div *ngIf="!category.isLoading && category.errorMessage" class="state-container error-state">
                        <p class="empty-message-text">{{category.errorMessage}}</p>
                    </div>

                    <!-- Line Chart Component -->
                    <div *ngIf="!category.isLoading && !category.errorMessage" class="chart-container">
                        <app-charts-line-chart [chart]="category.chartData"></app-charts-line-chart>
                    </div>
                </div>

                <!-- Summary Stats -->
                <div class="card-stats" *ngIf="!category.isLoading && !category.errorMessage">
                    <div class="stat-item">
                        <span class="stat-label">Latest</span>
                        <span class="stat-value" *ngIf="category.selectedReading && category.selectedReading.value !== null; else noLatestVal">
                            {{category.selectedReading.value | number:'1.0-2'}} <span class="stat-unit">{{category.selectedReading.unit || ''}}</span>
                        </span>
                        <ng-template #noLatestVal>
                            <span class="stat-value no-val">N/A</span>
                        </ng-template>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">Average</span>
                        <span class="stat-value" *ngIf="category.stats; else noAvgVal">
                            {{category.stats.average}} <span class="stat-unit">{{category.selectedReading?.unit || ''}}</span>
                        </span>
                        <ng-template #noAvgVal>
                            <span class="stat-value no-val">N/A</span>
                        </ng-template>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">Peak</span>
                        <span class="stat-value" *ngIf="category.stats; else noPeakVal">
                            {{category.stats.peak}} <span class="stat-unit">{{category.selectedReading?.unit || ''}}</span>
                        </span>
                        <ng-template #noPeakVal>
                            <span class="stat-value no-val">N/A</span>
                        </ng-template>
                    </div>
                    <div class="stat-item">
                        <span class="stat-label">Readings</span>
                        <span class="stat-value" *ngIf="category.stats; else noCountVal">
                            {{category.stats.count}}
                        </span>
                        <ng-template #noCountVal>
                            <span class="stat-value no-val">0</span>
                        </ng-template>
                    </div>
                    <div class="stat-item last-reading">
                        <span class="stat-label">Last Reading:</span>
                        <span class="stat-value" *ngIf="category.selectedReading && category.selectedReading.timestamp; else noTimestamp">
                            {{category.selectedReading.timestamp | date:'dd-MMM-yyyy HH:mm'}}
                            <span *ngIf="category.selectedReading.isStale" class="status-badge badge-stale inline-badge">Stale</span>
                            <span *ngIf="category.selectedReading.isIncomplete" class="status-badge badge-incomplete inline-badge" [title]="category.selectedReading.availableChannelCount + ' of ' + category.selectedReading.expectedChannelCount + ' channels available for this timestamp.'">
                                Partial ({{category.selectedReading.availableChannelCount}}/{{category.selectedReading.expectedChannelCount}})
                            </span>
                        </span>
                        <ng-template #noTimestamp>
                            <span class="stat-value no-val">No reading available</span>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- My Utilities View -->
    <div class="cards-grid" *ngIf="dashboardMode === 'my-utilities'">
        <div *ngFor="let category of categories" class="category-card">
            <div class="card-header">
                <div class="header-left">
                    <h3>{{category.name || category.key}}</h3>
                    <span class="range-label" *ngIf="category.matchedGroup && category.dateRangeLabel">{{category.dateRangeLabel}}</span>
                </div>
                <button mat-button *ngIf="category.chartData && !category.isLoading"
                        class="export-btn" (click)="exportToCSV(category)">
                    Export CSV
                </button>
            </div>

            <div class="card-content-area">
                <!-- Loading Spinner -->
                <div *ngIf="category.isLoading" class="state-container">
                    <mat-spinner [diameter]="40"></mat-spinner>
                </div>

                <!-- Error / Empty State Message -->
                <div *ngIf="!category.isLoading && category.errorMessage" class="state-container error-state">
                    <p class="empty-message-text">{{category.errorMessage}}</p>
                </div>

                <!-- Line Chart Component -->
                <div *ngIf="!category.isLoading && !category.errorMessage" class="chart-container">
                    <app-charts-line-chart [chart]="category.chartData"></app-charts-line-chart>
                </div>
            </div>

            <!-- Summary Stats -->
            <div class="card-stats" *ngIf="category.stats && !category.isLoading && !category.errorMessage">
                <div class="stat-item">
                    <span class="stat-label">Total</span>
                    <span class="stat-value">{{category.stats.total}}</span>
                </div>
                <div class="stat-item">
                    <span class="stat-label">Average</span>
                    <span class="stat-value">{{category.stats.average}}</span>
                </div>
                <div class="stat-item">
                    <span class="stat-label">Peak</span>
                    <span class="stat-value">{{category.stats.peak}}</span>
                </div>
                <div class="stat-item">
                    <span class="stat-label">Readings</span>
                    <span class="stat-value">{{category.stats.count}}</span>
                </div>
                <div class="stat-item last-reading">
                    <span class="stat-label">Last Reading:</span>
                    <span class="stat-value">{{category.stats.lastReading}}</span>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button (click)="onNoClick()">
        Close
    </button>
</mat-dialog-actions>